import { useEffect, useState } from 'react';

/**
 * Le navigateur a-t-il du réseau ?
 *
 * <p>`navigator.onLine` ne garantit pas que le serveur répond, mais quand il
 * dit non, il a raison : c'est le cas du chantier sans couverture, et c'est
 * là que l'utilisateur doit savoir que ce qu'il saisit attend.
 *
 * @returns {boolean} faux quand l'appareil est hors ligne
 */
export function useEnLigne() {
  const [enLigne, setEnLigne] = useState(() =>
    typeof navigator === 'undefined' || navigator.onLine === undefined ? true : navigator.onLine,
  );
  useEffect(() => {
    const oui = () => setEnLigne(true);
    const non = () => setEnLigne(false);
    window.addEventListener('online', oui);
    window.addEventListener('offline', non);
    return () => {
      window.removeEventListener('online', oui);
      window.removeEventListener('offline', non);
    };
  }, []);
  return enLigne;
}
